import React from 'react';
import './NavIcon.css';

interface NavIconProps {
  type: 'home' | 'squad' | 'standings' | 'history';
  size?: number;
  isActive?: boolean;
}

const NavIcon: React.FC<NavIconProps> = ({ type, size = 24, isActive = false }) => {
  const iconPaths: { [key: string]: { normal: string; active: string } } = {
    home: {
      normal: '/icons/ana-sayfa-icon.png.png',
      active: '/icons/ana-sayfa-icon-active.png.png'
    },
    squad: {
      normal: '/icons/kadro-icon.png.png',
      active: '/icons/kadro-icon-active.png.png'
    },
    standings: {
      normal: '/icons/puan-durumu-icon.png.png',
      active: '/icons/puan-durumu-icon-active.png.png'
    },
    history: {
      normal: '/icons/gecmis-icon.png.png',
      active: '/icons/gecmis-icon-active.png.png'
    },
  };

  const iconPath = isActive ? iconPaths[type].active : iconPaths[type].normal;

  return (
    <img 
      src={iconPath} 
      alt={type} 
      className="nav-icon-img"
      style={{ width: size, height: size }}
      onError={(e) => {
        // Aktif ikon yüklenemezse normal ikonu göster
        if (isActive) {
          e.currentTarget.src = iconPaths[type].normal;
        } else {
          e.currentTarget.style.display = 'none';
        }
      }}
    />
  );
};

export default NavIcon;

